import React from 'react';
import {observer} from "mobx-react";
import { LogOutLinkBox } from './boxes/log-out-link.box';
import {CyClass} from '../../../common/cy-classes';
import {useServices} from '../../react-hooks/use-services.hook';
import {UserMenuSectionBox} from '../user-menu/user-menu/boxes/section/user-menu-section.box';

export const UserMenuLogout: React.FC = observer(() => {
    const services = useServices();
    const translator = services.translation;
    const onClickHandler = async () => {
        (await services.userMenu).doLogout();
    }

    return <UserMenuSectionBox className={CyClass('cy-useful-links-section')}>
        <LogOutLinkBox className={`${CyClass('cy-logout-link')} ${CyClass('cy-useful-links-item')} ${CyClass('cy-useful-links-li-item')}`}
                       onClick={onClickHandler}>
            {translator.translate("LOGOUT")}
        </LogOutLinkBox>
    </UserMenuSectionBox>;
});
